<template>
  <v-row class="fill-height" no-gutters>
    <v-col cols="12">
      <v-banner single-line color="secondary" class="white--text" v-if="!getEnableAudio">
        <v-icon slot="icon" color="white" size="36">
          mdi-volume-off
        </v-icon>
        Browsers mute audio until you interact. Tap “Enable Audio” to allow notification sounds.

        <template v-slot:actions>
          <v-btn color="white" outlined @click="$store.commit('setEnableAudio', true)">
            Enable Audio
          </v-btn>
        </template>
      </v-banner>
    </v-col>
    <v-col cols="12">
      <kiosk-list></kiosk-list>
    </v-col>
    <v-btn @click="pullFaqs()">Pull FAQs</v-btn>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import KioskList from '../components/dashboard/admin/homeUI/kioskList.vue';
import TelepresenceNotes from '../components/telepresenceNotes.vue';
import * as XLSX from 'xlsx';
import axios from 'axios';
export default {
  name: 'home',
  data() {
    return {
      selectedKiosk: '',
      enableAudio: false
    }
  },
  components: {
    TelepresenceNotes,
    KioskList
  },
  computed: {
    ...mapGetters(["userProfile", "getDeviceSpec", "allRegisteredKiosks", "isSuperAdmin", "isAdmin", "isClientAdmin", "getEnableAudio"]),
    kioskList() {
      let kioskName = [];
      this.allRegisteredKiosks.forEach((kiosk) =>
        kioskName.push(kiosk.data().name)
      );
      return kioskName;
    },
  },
  methods: {
    pullFaqs() {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `https://cms.dekalb.arsconnect.com/faqs?kioskLocationCode_contains=ID1&_limit=-1`,
      }

      axios.request(config).then((response) => {
        console.log('Response from strapi: ', response.data);
        const ws = XLSX.utils.json_to_sheet(response.data);

        // 2) Create workbook and append sheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Data");

        // 3) Trigger download as .xlsx
        XLSX.writeFile(wb, "data.xlsx");
      }).catch((error) => {
        console.error("Error fetching data:", error);
      });

    }
  },
  mounted() {
    //
  }
}
</script>
<style>
.cardBorder {
  border-width: 1px;
  border-style: solid;
  border-color: #2c6b87 !important;
  border-radius: 5px !important;
}
</style>